import React from "react";
import { NavLink } from "react-router-dom";
import { Menu, Icon } from "antd";
import MenuWrapper from "./Menu.style";

const SubMenu = Menu.SubMenu;

const MenuComponent = ({
  role,
  openKeys,
  selectedKeys,
  onSubMenuSelect,
  onMenuItemClick,
}) => {
  let menu_items;

  if (role === "SUPERADMIN") {
    menu_items = [
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub1"
        title={
          <span>
            <Icon type="user" />
            <span>User</span>
          </span>
        }
      >
        <Menu.Item key="1">
          <NavLink to="/home/users/add">Add User</NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/home/users/update">Update User</NavLink>
        </Menu.Item>
      </SubMenu>,
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub2"
        title={
          <span>
            <Icon type="bar-chart" />
            <span>IC</span>
          </span>
        }
      >
        <Menu.Item key="3">
          <NavLink to="/home/ic/config-add">Add Config</NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/home/ic/config-update">Update Config</NavLink>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/home/ic/file-upload">Upload File</NavLink>
        </Menu.Item>
        <Menu.Item key="6">
          <NavLink to="/home/ic/file-publish">Publish Files</NavLink>
        </Menu.Item>
        <Menu.Item key="7">
          <NavLink to="/home/ic/download-data">Download Data</NavLink>
        </Menu.Item>
      </SubMenu>,
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub3"
        title={
          <span>
            <Icon type="bars" />
            <span>Miscellaneous</span>
          </span>
        }
      >
        <Menu.Item key="8">
          <NavLink to="/home/misc/config-parameters">
            Add Config Parameters
          </NavLink>
        </Menu.Item>
      </SubMenu>,
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub4"
        title={
          <span>
            <Icon type="team" />
            <span>Clients</span>
          </span>
        }
      >
        <Menu.Item key="9">
          <NavLink to="/home/client/add">Add Client</NavLink>
        </Menu.Item>
        <Menu.Item key="10">
          <NavLink to="/home/client/update">Update Client</NavLink>
        </Menu.Item>
      </SubMenu>,
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub5"
        title={
          <span>
            <Icon type="database" />
            <span>Box</span>
          </span>
        }
      >
        <Menu.Item key="11">
          <NavLink to="/home/box/file-upload">Upload Files</NavLink>
        </Menu.Item>
        <Menu.Item key="12">
          <NavLink to="/home/box/attach-reports">Attach Reports</NavLink>
        </Menu.Item>
        <Menu.Item key="13">
          <NavLink to="/home/box/assign-reports">Assign Reports</NavLink>
        </Menu.Item>
        <Menu.Item key="14">
          <NavLink to="/home/box/customization">Customization</NavLink>
        </Menu.Item>
        <Menu.Item key="15">
          <NavLink to="/home/box/chats">Chats</NavLink>
        </Menu.Item>
      </SubMenu>,
    ];
  } else if (role === "ADMIN") {
    menu_items = [
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub1"
        title={
          <span>
            <Icon type="user" />
            <span>User</span>
          </span>
        }
      >
        <Menu.Item key="1">
          <NavLink to="/home/users/add">Add User</NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/home/users/update">Update User</NavLink>
        </Menu.Item>
      </SubMenu>,
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub2"
        title={
          <span>
            <Icon type="bar-chart" />
            <span>IC</span>
          </span>
        }
      >
        <Menu.Item key="3">
          <NavLink to="/home/ic/config-add">Add Config</NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/home/ic/config-update">Update Config</NavLink>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/home/ic/file-upload">Upload File</NavLink>
        </Menu.Item>
        <Menu.Item key="6">
          <NavLink to="/home/ic/file-publish">Publish Files</NavLink>
        </Menu.Item>
        <Menu.Item key="7">
          <NavLink to="/home/ic/download-data">Download Data</NavLink>
        </Menu.Item>
      </SubMenu>,
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub3"
        title={
          <span>
            <Icon type="bars" />
            <span>Miscellaneous</span>
          </span>
        }
      >
        <Menu.Item key="8">
          <NavLink to="/home/misc/config-parameters">
            Add Config Parameters
          </NavLink>
        </Menu.Item>
      </SubMenu>,
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub4"
        title={
          <span>
            <Icon type="team" />
            <span>Clients</span>
          </span>
        }
      >
        <Menu.Item key="9">
          <NavLink to="/home/client/add">Add Client</NavLink>
        </Menu.Item>
        <Menu.Item key="10">
          <NavLink to="/home/client/update">Update Client</NavLink>
        </Menu.Item>
      </SubMenu>,
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub5"
        title={
          <span>
            <Icon type="database" />
            <span>Box</span>
          </span>
        }
      >
        <Menu.Item key="11">
          <NavLink to="/home/box/file-upload">Upload Files</NavLink>
        </Menu.Item>
        <Menu.Item key="12">
          <NavLink to="/home/box/attach-reports">Attach Reports</NavLink>
        </Menu.Item>
        <Menu.Item key="13">
          <NavLink to="/home/box/assign-reports">Assign Reports</NavLink>
        </Menu.Item>
        <Menu.Item key="14">
          <NavLink to="/home/box/customization">Customization</NavLink>
        </Menu.Item>
        <Menu.Item key="15">
          <NavLink to="/home/box/chats">Chats</NavLink>
        </Menu.Item>
      </SubMenu>,
    ];
  } else if (role === "NONADMIN") {
    menu_items = [
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub1"
        title={
          <span>
            <Icon type="bar-chart" />
            <span>IC</span>
          </span>
        }
      >
        <Menu.Item key="1">
          <NavLink to="/home/ic/config-add">Add Config</NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/home/ic/config-update">Update Config</NavLink>
        </Menu.Item>
        <Menu.Item key="3">
          <NavLink to="/home/ic/file-upload">Upload File</NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/home/ic/file-publish">Pulish Files</NavLink>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/home/ic/download-data">Download Data</NavLink>
        </Menu.Item>
      </SubMenu>,
    ];
  } else if (role === "SALES") {
    menu_items = [
      <SubMenu
        onTitleClick={onSubMenuSelect}
        key="sub1"
        title={
          <span>
            <Icon type="team" />
            <span>Clients</span>
          </span>
        }
      >
        <Menu.Item key="1">
          <NavLink to="/home/client/add">Add Client</NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/home/client/update">Update Client</NavLink>
        </Menu.Item>
      </SubMenu>,
    ];
  }

  return (
    <MenuWrapper>
      <div className="menu-container">
        <Menu
          mode="inline"
          inlineCollapsed={false}
          openKeys={openKeys}
          selectedKeys={selectedKeys}
          onSelect={onMenuItemClick}
        >
          {menu_items}
        </Menu>
      </div>
    </MenuWrapper>
  );
};

export default MenuComponent;



// WEBPACK FOOTER //
// ./src/components/SideMenu/Menu/Menu.js